import { TimeslotContentMapper } from './timeslotContentMapper'
import { TimeslotResponseDTO } from '../dtos/response/timeslot/timeslot'
import { Timeslot } from '../entities/timeslot'

export class TimeslotMapper {
	static toEntity(data: TimeslotResponseDTO): Timeslot {
		return new Timeslot({
			id: data.id,
			scheduleId: data.schedule_id,
			name: data.name,
			type: data.type,
			vevent: data.vevent,
			priority: data.priority,
			timeslotContents:
				data.timeslot_contents?.data.map((content) =>
					TimeslotContentMapper.toEntity(content)
				) || [],
		})
	}
}
